module.exports = __webpack_public_path__ + "static/media/pattern-2.203aa84f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pattern-2.png
// module id = 674
// module chunks = 0